<template>
  <ws-chip v-if="asChip && fromTo.length>8" :is-disabled="isDisabled" v-model="fromTo"></ws-chip>
  <div v-else-if="fromTo.length>8">{{ fromTo }}</div>
</template>
<script>
import WsChip from '@/modules/customerVbzWorksheet/components/WsChip.vue';
import wsMixin from "@/modules/customerVbzWorksheet/wsMixin";

export default {
  name: 'FromTo',
  mixins: [wsMixin],
  components: { WsChip },
  props: {
    column: Object,
    absence: Object,
    isAssignedToDifferentView: Boolean,
    isDisabled: { type: Boolean, default: false },
    asChip: { type: Boolean, default: true },
  },

  computed: {
    fromTo() {
      const columnName=this.column.columnName
      let fromTo= columnName==='z9FromTo'?this.mx_z9FromTo(this.absence):this.mx_fromTo(this.absence);
      return fromTo;
    },
  },
};
</script>
